import React from 'react';
import { useDispatch } from 'react-redux';
import { exportEventHistoryCsv } from '../../actions/eventHistoryActions';

export interface IEventHistory {
    date: string;
    time: string;
    event: string;
    eventName: string;
    originator: string;
    value: string;
}

interface EventHistoryCardProps {
    eventHistory: IEventHistory[];
    installBaseID: string;
}

const EventHistoryCard: React.FC<EventHistoryCardProps> = ({
    eventHistory,
    installBaseID
}) => {
    const dispatch = useDispatch();

    const getLatestEventTimestamp = (): string => {
        if (!eventHistory || eventHistory.length === 0) return '';

        const latest = eventHistory[0];
        const date = latest.date;
        const time = latest.time;

        // Determine AM/PM
        const [hours, minutes] = time.split(':');
        const hour = parseInt(hours, 10);
        const period = hour >= 12 ? 'pm' : 'am';

        return `${date}: ${time} ${period}`;
    };

    const handleExportHistory = () => {
        if (installBaseID) {
            dispatch(exportEventHistoryCsv(installBaseID) as any);
        }
    };

    if (!eventHistory || eventHistory.length === 0) {
        return null;
    }

    return (
        <div className="event-history-card">
            <div className="event-history-card-header">
                <h3>Event History</h3>
            </div>
            <div className="event-history-table-container">
                <table className="event-history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Time EST.</th>
                            <th>Event</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventHistory.map((item, index) => (
                            <tr key={`${item.date}-${item.time}-${index}`}>
                                <td>{item.date}</td>
                                <td>{item.time}</td>
                                <td className="event-originator">
                                    {item.event === 'General Shutdown Cleared'
                                        ? 'Alert Cleared'
                                        : item.originator}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="event-history-footer">
                <span className="event-history-updated">
                    Updated: {getLatestEventTimestamp()}
                </span>
                <button
                    className="event-history-export-button"
                    onClick={handleExportHistory}
                >
                    Export History
                </button>
            </div>
        </div>
    );
};

export default EventHistoryCard;
